import { select as d3Select} from 'd3-selection';
import { area as d3Area } from 'd3-shape';
import { axisBottom as d3AxisBottom } from 'd3-axis';

import { isMobile } from '../../helper/utils';

const area = (x ,y) => d3Area()
 .x((d, i) => x(new Date(d.data.date, 0, 1)))
 .y0((d, i) =>  y(d[0]))
 .y1((d, i) => y(d[1]));


export const createLayer = (root, data, x, y, z) => {
  const layer = root.selectAll('.layer')
    .data(data)
    .enter()
    .append('g')
    .classed('layer', true);

  layer.append('path')
    .attr('class', 'area')
    .style('fill', (d, i) => z(i))
    .style('stroke-width', 1)
    .style('stroke', (d, i) => z(i))
    .attr('d', area(x, y));

  return layer;
}

export const createVerticalLine = () => {
  const verticalLine = d3Select('.chartContainer')
    .append('div')
    .attr('class', 'vertical-line')
    .style('bottom', '20px')
    .style('opacity', 0);

  return verticalLine;
}

export const createXAxis = (root, containerHeight, x) => {
  const tickValues = isMobile ? [1990, 2002, 2014] : [1990, 1995, 2000, 2005, 2010, 2014];
  const xAxis = d3AxisBottom(x)
    .tickValues(tickValues.map(d => new Date(d, 0, 1)));

  const xAxisEl = root.append('g')
    .attr('class', 'x-axis')
    .attr('transform', `translate(0, ${ containerHeight - 20 })`)
    .call(xAxis);

  xAxisEl.selectAll('.tick')
    .style('text-anchor', (d, i, nodes) => {
      if (i === 0) {
        return 'start'
      }
      return 'mid';
    });

  xAxisEl.selectAll('.tick').select('text')
    .attr('dx', (d, i, nodes)  => {
      if (i === 0) {
        return 10;
      }
      else if (i === nodes.length -1) {
        return -20;
      }
      return 0;
    });

  return xAxisEl;
}

export const createMarker = (root, data) => {
  const marker = root.selectAll('.marker')
    .data(data)
    .enter()
    .append('circle')
    .classed('marker', true)
    .attr('r', 1.5)
    .style('fill', '#FFFFFF')
    .style('pointer-events', 'none')
    .style('fill-opacity', 0);

  return marker;
}

export const createMarkerLabel = (root) => {
  const label = root.append('text')
    .classed('marker-label', true)
    .style('fill-opacity', 0)
    .style('pointer-events', 'none');

  return label;
}



// WEBPACK FOOTER //
// ./src/Component/AreaChart/helper.js